import 'reflect-metadata'
import { AccessControlPolicy } from '@repo/alt/Services'
import { inject, injectable, injectFromBase } from 'inversify'

import { UserService } from '#User/services'

@injectable()
@injectFromBase({ extendConstructorArguments: true })
export class UserAccessControlPolicy extends AccessControlPolicy {
  static override namespace = 'user'

  constructor(
    @inject(UserService) readonly $userService: UserService,
  ) {
    super()
  }
}
